<template>
  <div id="container">
    <amap :zoom="15" :center="position">
      <amap-marker
        :position="position"
        :label="label">
      </amap-marker>
    </amap>
  </div>
</template>

<script>

export default {
  name: "Maps",
  data(){
    return{
      position:[117.121948, 31.82164],
      label:{
        direction:'bottom'
      }
    }
  }
}
</script>

<style scoped>
  #container{
    border-radius: 2px;
    box-shadow: 0 2px 4px rgba(0, 0, 255, .12), 0 0 6px rgba(0, 0, 255, .04);
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
    height: 100%;
    width: 100%;
  }
</style>
